import React from 'react'

const WhyCard = ({info,title}) => {
  return (
    <div className={`flex flex-col gap-1 p-4 bg-[#353579] text-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ebff84] hyphens-none`}>
        <h3 className='text-xl font-bold text-[#ebff84]'>{title}</h3>
        <p >{info}</p>
    </div>
  )
}

export default WhyCard